import * as XLSX from 'xlsx';
import { AlertError } from "../../usableclasses.js";

export const handleExportToExcel = (stockItems, allStocks, getSelectedStockName, setIsLoading) => {
    if (stockItems.length === 0) {
        AlertError("No data to export.");
        return;
    }
    if (setIsLoading) setIsLoading(true);

    // Prepare data for Excel
    const dataForExcel = stockItems.map(item => ({
        "Product Code": item.itemSku,
        "Name": item.itemName,
        "Size": item.itemSize,
        "UOM": item.unitOfMeasure,
        "Available Qty": item.availableQty,
        "Total Stock Value": parseFloat(item.itemTotalCostValue || 0).toFixed(2)
    }));

    // Add total row
    const totalQty = stockItems.reduce((sum, item) => sum + (Number(item.availableQty) || 0), 0);
    const totalValue = stockItems.reduce((sum, item) => sum + (parseFloat(item.itemTotalCostValue) || 0), 0);
    dataForExcel.push({}); // Empty row for spacing
    dataForExcel.push({ "Name": "Total", "Available Qty": totalQty, "Total Stock Value": totalValue.toFixed(2) });

    const worksheet = XLSX.utils.json_to_sheet(dataForExcel);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Stock Report");
    const excelFileName = `Stock_Report_${allStocks ? 'All_Stocks' : getSelectedStockName().replace(/\s+/g, '_')}_${new Date().toISOString().slice(0, 10)}.xlsx`;
    XLSX.writeFile(workbook, excelFileName);
    if (setIsLoading) setIsLoading(false);
};